
class TagBasedCollectionUpdater {
  static instance = null;

  constructor(productGridId, shimmerContainerSelector) {
    if (TagBasedCollectionUpdater.instance) {
      return TagBasedCollectionUpdater.instance;
    }
    this.productGrid = document.getElementById('product-grid');
    this.collectionHandle = this.productGrid?.dataset.collectionHandle;
    this.currentPage = 1;
    this.totalPages = 1;
    this.fetching = false;
    this.shimmerContainer = document.querySelector(shimmerContainerSelector);
    this.lastProductCard = null;

    TagBasedCollectionUpdater.instance = this;
    const collectionDataScript = document.getElementById("collection-data");
    this.collectionData = null;

    try {
      if (collectionDataScript?.textContent.trim()) {
        this.collectionData = JSON.parse(collectionDataScript.textContent);
      } else {
        console.error("Collection data is missing or empty.");
      }
    } catch (error) {
      console.error("Failed to parse collection data:", error);
    }

    this.sortingCollectionUrl = this.productGrid?.dataset.sortingCollectionHandle;

    if (this.collectionHandle && ![this.sortingCollectionUrl, 'all'].includes(this.collectionHandle)) {

      //this.shimmerContainer.classList.remove("hidden");
      this.initializeObserver();
      this.updateProductGrid().then(() => {
        this.observeLastProductCard();
        if (typeof removeDuplicateProducts === 'function') removeDuplicateProducts();

        //this.shimmerContainer.classList.add("hidden");
        //.querySelector('#product-grid').classList.remove('hidden');
      });
    } else {

      //this.shimmerContainer.classList.add("hidden");
      //document.querySelector('#product-grid').classList.remove('hidden');
    }
  }

  initializeObserver() {
    const observerOptions = {
      root: null,
      threshold: 0.5
    };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.fetching && this.currentPage <= this.totalPages) {
          this.observer.unobserve(entry.target);
          this.updateProductGrid().then(() => {
            this.observeLastProductCard();
          });
        }
      });
    }, observerOptions);
  }

  observeLastProductCard() {
    if (this.lastProductCardId) {
      const lastProductCardElement = document.getElementById('product-grid').querySelector(`[data-product-id="${this.lastProductCardId}"]`).querySelector("mm-product-card");
      if (lastProductCardElement) {
        this.observer.observe(lastProductCardElement);
      }
    }
  }
  generateFilterUrl(rules, baseUrl, page) {
    if (!rules || rules.length == 0) {
      let collectionUrl = `/collections/${this.collectionHandle}?view=custom-collection&page=${page}`;
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.forEach((value, key) => {
        collectionUrl += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
      return collectionUrl;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const existingFilters = new Set(urlParams.keys());
    const queryParams = [...urlParams.entries()].map(
      ([key, value]) => `${key}=${encodeURIComponent(value)}`
    );

    const processedColumns = new Set();
    const isValidTag = (condition) => /^[a-zA-Z0-9_-]+$/.test(condition);

    rules.forEach((rule) => {
      if (processedColumns.has(rule.column)) return;
      let filter = "";
      switch (rule.column) {
        case "tag":
          if (rule.relation === "equals" && isValidTag(rule.condition)) {
            filter = `filter.p.tag=${encodeURIComponent(rule.condition)}`;
          } else {
            document
              .querySelectorAll('input[name="filter.p.product_type"]')
              .forEach((input) => {
                const value = input.dataset.value || input.value;
                if (value && !existingFilters.has("filter.p.product_type")) {
                  if (!queryParams.includes(`filter.p.product_type=${encodeURIComponent(value)}`)) {
                    queryParams.push(
                      `filter.p.product_type=${encodeURIComponent(value)}`
                    );
                  }
                }
              });
          }
          break;

        case "type":
          if (rule.relation === "equals") {
            filter = `filter.p.product_type=${encodeURIComponent(rule.condition)}`;
          } else if (rule.relation === "not_equals") {
            document
              .querySelectorAll('input[name="filter.p.product_type"]')
              .forEach((input) => {
                const value = input.dataset.value || input.value;
                if (value && !existingFilters.has("filter.p.product_type")) {
                  if (!queryParams.includes(`filter.p.product_type=${encodeURIComponent(value)}`)) {
                    queryParams.push(
                      `filter.p.product_type=${encodeURIComponent(value)}`
                    );
                  }
                }
              });
            processedColumns.add(rule.column);
          }
          break;

        case "vendor":
          if (rule.relation === "equals") {
            filter = `filter.p.vendor=${encodeURIComponent(rule.condition)}`;
          } else if (rule.relation === "not_equals") {
            document
              .querySelectorAll('input[name="filter.p.vendor"]')
              .forEach((input) => {
                const value = input.dataset.value || input.value;
                if (value && !existingFilters.has("filter.p.vendor")) {
                  if (!queryParams.includes(`filter.p.vendor=${encodeURIComponent(value)}`)) {
                    queryParams.push(
                      `filter.p.vendor=${encodeURIComponent(value)}`
                    );
                  }
                }
              });
            processedColumns.add(rule.column);
          }
          break;

        case "variant_price":
          if (rule.relation === "less_than") {
            filter = `filter.v.price.ite=${encodeURIComponent(rule.condition)}`;
          } else if (rule.relation === "greater_than") {
            filter = `filter.v.price.gte=${encodeURIComponent(rule.condition)}`;
          }
          break;

        default:
          console.warn(`Unsupported rule: ${JSON.stringify(rule)}`);
          break;
      }

      if (filter && !existingFilters.has(filter.split("=")[0])) {
        if (!queryParams.includes(filter)) {
          queryParams.push(filter);
        }
      }
    });

    return `${baseUrl}?view=custom-collection&${queryParams.join("&")}&page=${page}`;
  }

  fetchNewProductCards(page) {
    const collectionUrl = this.generateFilterUrl(this.collectionData.rules, this.sortingCollectionUrl, page)
    return fetch(collectionUrl)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.text();
      })
      .then(htmlString => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const paginationElement = doc.querySelector('#magepow-Pagination');
        if (paginationElement) {
          const anchorElements = paginationElement.querySelectorAll('a');
          let maxPage = 1;
          anchorElements.forEach(anchor => {
            const url = new URL(anchor.href);
            if (url) {
              maxPage = url.search.split("&").filter(query => query.includes("page"))[0].split("=")[1];
            }
          });
          this.totalPages = maxPage || 1;
        } else {
          this.totalPages = 1;
        }
        return doc.querySelector('#product-grid');
      })
      .catch(error => {
        console.error('Error fetching product grid:', error);
      });
  }

  appendNewProductCards(newProductGrid) {
    if (newProductGrid) {
      const productGrid = document.querySelector('.product-grid');
      const bannerElement = document.querySelector(".product-grid__sale-image");
      const newProductsHTML = Array.from(newProductGrid.querySelectorAll("li")).reverse();

      const initialProductCards = productGrid.querySelectorAll('.grid__item');
      let cardproducts = []
      initialProductCards.forEach((ele) => {
        cardproducts.push(ele.getAttribute('data-product-id'));
      })

      if (!this.lastProductCardId) {
        newProductsHTML.forEach((productCard, index) => {
          if (bannerElement) {
            productGrid.insertAdjacentHTML('afterbegin', bannerElement.outerHTML);
          }
          productGrid.insertAdjacentHTML('afterbegin', productCard.outerHTML);
          if (index === 0) {
            this.lastProductCardId = productCard.dataset.productId;
          }
        });
      } else {
        const referenceElement = document.getElementById('product-grid').querySelector(`[data-product-id="${this.lastProductCardId}"]`).nextElementSibling;

        newProductsHTML.forEach((productCard, index) => {
          if (!cardproducts.includes(productCard.getAttribute('data-product-id'))) {
            if (bannerElement) {
              const clonedBanner = bannerElement.cloneNode(true);
              referenceElement.parentNode.insertBefore(clonedBanner, referenceElement.nextSibling);
            }
            referenceElement.parentNode.insertBefore(productCard, referenceElement.nextSibling);
            if (index === 0) {
              this.lastProductCardId = productCard.dataset.productId;
            }
          }
        });
      }
    }
  }


  updateProductGrid() {
    return new Promise((resolve, reject) => {
      if (this.currentPage <= this.totalPages && !this.fetching && this.collectionHandle && ![this.sortingCollectionUrl, 'all'].includes(this.collectionHandle) && this.sortingCollectionUrl) {
        this.fetching = true;
        //this.shimmerContainer.classList.remove("hidden");        
        document.body.classList.add("overflow-hidden")
        document.querySelector(".collection")?.classList.add("loading")
        document.querySelector('.product-grid').classList.add('hidden');

        this.fetchNewProductCards(this.currentPage)
          .then(newProductGrid => {
            if (newProductGrid) {
              this.appendNewProductCards(newProductGrid);
              this.currentPage++;
            }
            resolve();
          })
          .catch(error => {
            console.error('Error in updateProductGrid:', error);
            reject(error);
          })
          .finally(() => {
            this.fetching = false;
            //this.shimmerContainer.classList.add("hidden");
            document.body.classList.remove("overflow-hidden")
            document.querySelector(".collection")?.classList.remove("loading")

            document.querySelector('.product-grid').classList.remove('hidden');
            document.querySelectorAll('#js-top-sort').forEach((item) => {
              item.classList.remove('hidden');
            })
          });
      } else {
        resolve();
        resetState();
      }
    });
  }

  resetState() {
    this.fetching = false;
    this.currentPage = 1;

    //this.shimmerContainer?.classList.add("hidden");
    //document.querySelector('#product-grid').classList.remove('hidden');

    this.lastProductCardId = null
  }
}
const productGridInstance = new TagBasedCollectionUpdater('product-grid', '.shimmer-container');

class FacetFiltersForm extends HTMLElement {

  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    // if (window.location.pathname.includes('/collections/')) {
    // 	const appenURl = "?filter.v.price.gte=&filter.v.price.lte=&filter.v.availability=1&sort_by=manual";			
    // 	if (!window.location.search.includes(appenURl)) {
    // 		window.location.href = window.location.pathname + appenURl;
    // 	}			
    // }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  // Shopify's size filter matches sold-out sizes too. Pairing it with the variant-level
  // availability filter limits results to products whose selected size is in stock.
  static withSizeStock(searchParams) {
    if (!window.location.pathname.includes('/collections/')) return searchParams;

    const params = new URLSearchParams(searchParams);
    const hasSize = params.has(FacetFiltersForm.SIZE_PARAM);
    const hasStock = params.has(FacetFiltersForm.STOCK_PARAM);

    if (hasSize && !hasStock) {
      params.append(FacetFiltersForm.STOCK_PARAM, '1');
      FacetFiltersForm.setAutoStock(true);
    } else if (!hasSize && FacetFiltersForm.getAutoStock()) {
      if (params.getAll(FacetFiltersForm.STOCK_PARAM).join() === '1') params.delete(FacetFiltersForm.STOCK_PARAM);
      FacetFiltersForm.setAutoStock(false);
    }

    return params.toString();
  }

  static getAutoStock() {
    try {
      return sessionStorage.getItem(FacetFiltersForm.AUTO_STOCK_KEY) === '1';
    } catch (error) {
      return FacetFiltersForm.autoStockFallback;
    }
  }

  static setAutoStock(value) {
    FacetFiltersForm.autoStockFallback = value;
    try {
      value
        ? sessionStorage.setItem(FacetFiltersForm.AUTO_STOCK_KEY, '1')
        : sessionStorage.removeItem(FacetFiltersForm.AUTO_STOCK_KEY);
    } catch (error) {}
  }

  static applySizeStockOnLoad() {
    const current = window.location.search.slice(1);
    if (!document.getElementById('product-grid')) return;

    const params = new URLSearchParams(current);
    if (!params.has(FacetFiltersForm.SIZE_PARAM)) {
      FacetFiltersForm.setAutoStock(false);
      return;
    }
    if (params.has(FacetFiltersForm.STOCK_PARAM)) return;

    const updated = FacetFiltersForm.withSizeStock(current);
    if (updated === current) return;

    history.replaceState({ searchParams: updated }, '', `${window.location.pathname}?${updated}`);
    FacetFiltersForm.searchParamsInitial = updated;
    FacetFiltersForm.renderPage(updated, null, false);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    searchParams = FacetFiltersForm.withSizeStock(searchParams);
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection')?.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
      setTimeout(function () { HulkappWishlist.init(); }, 800);
    });

    document.querySelector('.collection_sorting_item ')?.removeAttribute('open');
    const issortOptions = document.querySelector('body')?.getAttribute('aria-selected') === 'sort-options' ? true : false;
    const details = document.querySelector('.mobile-facets__disclosure');
    if (issortOptions && details) {
      details.removeAttribute('open');
      document.querySelector('body').classList.remove('overflow-hidden')
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (TagBasedCollectionUpdater.instance) {
          TagBasedCollectionUpdater.instance.resetState();
          TagBasedCollectionUpdater.instance.updateProductGrid().then(() => {
            TagBasedCollectionUpdater.instance.observeLastProductCard();
            if (typeof removeDuplicateProducts === 'function') removeDuplicateProducts();
            HulkappWishlist.init();
          });
        }
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (TagBasedCollectionUpdater.instance) {
      TagBasedCollectionUpdater.instance.resetState();
      TagBasedCollectionUpdater.instance.updateProductGrid().then(() => {
        TagBasedCollectionUpdater.instance.observeLastProductCard()
        if (typeof removeDuplicateProducts === 'function') removeDuplicateProducts();
        HulkappWishlist.init();
      });
    }
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {

    const productGrid = document.getElementById('ProductGridContainer').querySelector("ul#product-grid")
    const parsedHtml = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer');
    const parsedHTMLProductGrid = parsedHtml.querySelector("ul#product-grid")
    parsedHtml.querySelector(".shimmer-container") ? parsedHtml.querySelector(".shimmer-container").classList.add("hidden") : null;
    if (productGrid && parsedHTMLProductGrid) {
      parsedHTMLProductGrid.classList = ''
      productGrid.classList.forEach(className => {
        parsedHTMLProductGrid.classList.add(className);
      });
    }

    document.getElementById('ProductGridContainer').innerHTML = parsedHtml.innerHTML

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    addLayout();
  }

  static rendersaleImages() {
    const productsList = document.querySelector(".product-grid");
    const saleImageDivTemplate = document.querySelector(".product-grid__sale-image");
    const products = Array.from(productsList.getElementsByClassName("grid__item"));
    console.log('rendersaleImages funcion');

    if (productsList && saleImageDivTemplate) {
      const existingSaleImages = productsList.querySelectorAll(".product-grid__sale-image");
      existingSaleImages.forEach((saleImage) => saleImage.remove());
      products.forEach((product, index) => {
        if ((index + 1) % 8 === 0) {
          const saleImageClone = saleImageDivTemplate.cloneNode(true);
          product.after(saleImageClone);
        }
      });
    }
  }
  static renderProductCount(html) {
    infiniteScroll();
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountDesktop').innerHTML;
    const container = document.getElementById('ProductCountDesktop');
    container.innerText = count;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document.getElementById(closestJSFilterID).classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
    addLayout();
    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  // validatePrice sets the min and max values for the price range input, if the min value is greater than the max value, it sets the min value to 0
  validatePrice(event) {
    const isMobile = window.innerWidth <= 749;
    this.minInput = isMobile ? document.getElementById('Mobile-Filter-Price-GTE') : document.getElementById('Filter-Price-GTE');
    this.maxInput = isMobile ? document.getElementById('Mobile-Filter-Price-LTE') : document.getElementById('Filter-Price-LTE');

    if (this.minInput && this.maxInput && event.target === this.maxInput) {
      const minPrice = parseInt(this.minInput.value);
      const maxPrice = parseInt(this.maxInput.value);
      const maxPriceMax = parseInt(this.maxInput.getAttribute('max'));
      if (minPrice > maxPrice) this.minInput.value = 0;
      if (maxPrice > maxPriceMax) this.maxInput.value = maxPriceMax;
    }
  }

  // Helper method to get all active filters from URL/searchParams
  getAllActiveFilters(searchParams) {
    if (!searchParams) {
      // Fallback to current URL if no searchParams provided
      searchParams = window.location.search.slice(1);
    }

    if (!searchParams) return { categories: [], values: [], filters: {} };

    try {
      const params = new URLSearchParams(searchParams);
      const filterData = {
        categories: [],
        values: [],
        filters: {}
      };

      // Map filter parameter names to human-readable category names
      const filterCategoryMap = {
        'filter.p.product_type': 'Product Type',
        'filter.p.vendor': 'Vendor',
        'filter.p.tag': 'Tag',
        'filter.v.price.gte': 'Price',
        'filter.v.price.lte': 'Price',
        'filter.v.availability': 'Availability'
      };

      // Get filter labels from DOM for better accuracy
      // IMPORTANT: For filter.v.option.*, always return "Product Option" as category
      // The DOM label (e.g., "Color") is the filter name, not the category
      const getFilterLabel = (paramName) => {
        // For variant options, category is always "Product Option"
        if (paramName.includes('filter.v.option.')) {
          return 'Product Option';
        }

        // For other filters, try to get label from DOM
        try {
          const filterInputs = document.querySelectorAll(`input[name="${paramName}"]`);
          if (filterInputs.length > 0) {
            const filterElement = filterInputs[0].closest('.js-filter');
            if (filterElement) {
              const labelElement = filterElement.querySelector('.facets__summary-label, .h5');
              if (labelElement && labelElement.textContent) {
                const label = labelElement.textContent.trim();
                if (label) return label;
              }
            }
          }
        } catch (e) {
          // Fall through to fallback
        }
        // Fallback to mapped category name
        return filterCategoryMap[paramName] || paramName.replace(/^filter\.(p|v)\./, '').replace(/\./g, ' ').replace(/\b\w/g, l => l.toUpperCase());
      };

      // Track price separately to combine gte and lte
      let priceMin = null;
      let priceMax = null;

      // Extract all filter parameters
      params.forEach((value, key) => {
        // Skip non-filter parameters
        if (!key || !key.startsWith('filter.') || key === 'sort_by' || key === 'view' || key === 'section_id' || key === 'page' || key === 'q') {
          return;
        }

        // Skip empty values
        if (value === '' || value === null || value === undefined) {
          return;
        }

        // Handle price filters specially
        if (key === 'filter.v.price.gte') {
          const numValue = parseFloat(value);
          if (!isNaN(numValue) && numValue >= 0) {
            priceMin = value;
          }
          return;
        }
        if (key === 'filter.v.price.lte') {
          const numValue = parseFloat(value);
          if (!isNaN(numValue) && numValue >= 0) {
            priceMax = value;
          }
          return;
        }

        // Get category name
        const categoryName = getFilterLabel(key);
        if (!categoryName) return;

        // Initialize category if not exists
        if (!filterData.filters[categoryName]) {
          filterData.filters[categoryName] = [];
          filterData.categories.push(categoryName);
        }

        // Decode and add value (handle multiple values for same filter)
        try {
          const decodedValue = decodeURIComponent(value).trim();
          if (decodedValue && !filterData.filters[categoryName].includes(decodedValue)) {
            filterData.filters[categoryName].push(decodedValue);
            filterData.values.push(decodedValue);
          }
        } catch (e) {
          // If decoding fails, use original value
          const trimmedValue = value.trim();
          if (trimmedValue && !filterData.filters[categoryName].includes(trimmedValue)) {
            filterData.filters[categoryName].push(trimmedValue);
            filterData.values.push(trimmedValue);
          }
        }
      });

      // Handle price range
      if (priceMin || priceMax) {
        const priceCategory = 'Price';
        let priceValue = '';
        const minNum = priceMin ? parseFloat(priceMin) : null;
        const maxNum = priceMax ? parseFloat(priceMax) : null;

        if (minNum !== null && maxNum !== null && !isNaN(minNum) && !isNaN(maxNum)) {
          priceValue = `₹${priceMin} - ₹${priceMax}`;
        } else if (minNum !== null && !isNaN(minNum)) {
          priceValue = `₹${priceMin}+`;
        } else if (maxNum !== null && !isNaN(maxNum)) {
          priceValue = `Up to ₹${priceMax}`;
        }

        if (priceValue) {
          if (!filterData.filters[priceCategory]) {
            filterData.filters[priceCategory] = [];
            filterData.categories.push(priceCategory);
          }
          if (!filterData.filters[priceCategory].includes(priceValue)) {
            filterData.filters[priceCategory].push(priceValue);
            filterData.values.push(priceValue);
          }
        }
      }

      return filterData;
    } catch (error) {
      console.error('Error extracting filter data:', error);
      return { categories: [], values: [], filters: {} };
    }
  }

  // GA4: Track filter applied event
  trackFilterApplied(event, searchParams = null) {
    const input = event.target;
    if (!input) return;

    // Only track when filter is being APPLIED (checked), not removed (unchecked)
    if (input.type === 'checkbox' && !input.checked) {
      return; // Don't track unchecked filters
    }

    // Prevent duplicate tracking from multiple forms (mobile/desktop)
    // Use a unique identifier for this specific input change
    const trackingKey = `${input.name}_${input.value}_${input.checked}`;
    const now = Date.now();

    // Check if we've already tracked this exact change in the last 500ms
    if (window._lastFilterTracking &&
      window._lastFilterTracking.key === trackingKey &&
      now - window._lastFilterTracking.time < 500) {
      return; // Skip duplicate tracking
    }

    // Store this tracking event
    window._lastFilterTracking = {
      key: trackingKey,
      time: now
    };

    // Get filter type and value with descriptive labels
    let filterType = '';
    let filterValue = '';
    let filterLabel = '';
    let category = '';
    let filterName = '';

    // Get collection handle from URL or page
    const pathParts = window.location.pathname.split('/');
    const collectionIndex = pathParts.indexOf('collections');
    if (collectionIndex !== -1 && pathParts[collectionIndex + 1]) {
      category = pathParts[collectionIndex + 1].replace(/-/g, ' ');
    }

    // Get descriptive label text
    filterLabel = this.getCleanLabelText(input) || input.value || '';

    // Determine filter type and value
    if (input.name && input.name.includes('filter.')) {
      filterName = input.name;

      // Handle different filter types
      if (filterName.includes('filter.p.tag')) {
        filterType = 'tag';
        filterValue = filterLabel || input.value || '';
      } else if (filterName.includes('filter.p.product_type')) {
        filterType = 'product_type';
        filterValue = filterLabel || input.value || '';
      } else if (filterName.includes('filter.p.vendor')) {
        filterType = 'vendor';
        filterValue = filterLabel || input.value || '';
      } else if (filterName.includes('filter.v.price')) {
        filterType = 'price';
        const minPrice = document.querySelector('[name="filter.v.price.gte"]')?.value || '';
        const maxPrice = document.querySelector('[name="filter.v.price.lte"]')?.value || '';
        if (minPrice && maxPrice) {
          filterValue = `₹${minPrice} - ₹${maxPrice}`;
        } else if (minPrice) {
          filterValue = `₹${minPrice}+`;
        } else if (maxPrice) {
          filterValue = `Up to ₹${maxPrice}`;
        } else {
          filterValue = '';
        }
      } else if (filterName.includes('filter.v.availability')) {
        filterType = 'availability';
        filterValue = input.checked ? 'in_stock' : 'all';
        filterLabel = input.checked ? 'In Stock' : 'All Products';
      } else if (filterName.includes('filter.v.option')) {
        // Color, Size, etc.
        const match = filterName.match(/filter\.v\.option\.(.+)/);
        if (match) {
          filterType = match[1].toLowerCase();
          filterValue = filterLabel || input.value || '';
        }
      } else {
        // Generic filter - extract readable name
        const filterParts = filterName.replace('filter.', '').split('.');
        filterType = filterParts[filterParts.length - 1] || filterName.replace('filter.', '').replace(/\./g, '_');
        filterValue = filterLabel || input.value || '';
      }
    }

    // Send to GA4 directly via gtag() if filter is being applied
    if (filterType && filterValue) {
      // Get all active filters from searchParams (passed from onSubmitHandler) or current URL
      const paramsToUse = searchParams || window.location.search.slice(1);
      const allFilters = this.getAllActiveFilters(paramsToUse);

      // filter_category should be the page/collection category (e.g., "raymond shirt", "shirts")
      // This is already extracted from URL as 'category' variable
      // filter_name is the specific filter type (e.g., "Color", "Size", "Product Type")
      let filterNameForGA = ''; // The actual filter name (e.g., "Color", "Size", "Product Type")

      if (filterName.includes('filter.p.tag')) {
        filterNameForGA = 'Tag';
      } else if (filterName.includes('filter.p.product_type')) {
        filterNameForGA = 'Product Type';
      } else if (filterName.includes('filter.p.vendor')) {
        filterNameForGA = 'Vendor';
      } else if (filterName.includes('filter.v.price')) {
        filterNameForGA = 'Price';
      } else if (filterName.includes('filter.v.availability')) {
        filterNameForGA = 'Availability';
      } else if (filterName.includes('filter.v.option.')) {
        const match = filterName.match(/filter\.v\.option\.(.+)/);
        if (match) {
          filterNameForGA = match[1].charAt(0).toUpperCase() + match[1].slice(1); // "Color", "Size", etc.
        } else {
          filterNameForGA = filterType.charAt(0).toUpperCase() + filterType.slice(1);
        }
      } else {
        filterNameForGA = filterType.charAt(0).toUpperCase() + filterType.slice(1);
      }

      const finalFilterName = filterNameForGA || filterType || '';
      const finalFilterValue = filterValue || filterLabel || '';

      if (finalFilterName && finalFilterValue) {
        const finalValue = String(finalFilterValue || filterLabel || filterValue || '').trim();

        if (!finalValue || finalValue === '') {
          console.warn('filter_value is empty, using fallback:', {
            finalFilterValue: finalFilterValue,
            filterLabel: filterLabel,
            filterValue: filterValue
          });
        }

        const ga4Params = {
          filter_category: String(category || ''),
          filter_name: String(finalFilterName),
          filter_value: finalValue || String(filterValue) || String(filterLabel) || '',
          filter_type: String(filterType || ''),
          filter_label: String(filterLabel || finalValue),
          page_location: String(window.location.href || ''),
          page_path: String(window.location.pathname || '')
        };

        if (typeof gtag !== 'undefined' && typeof gtag === 'function') {
          try {
            const eventParams = {
              filter_category: ga4Params.filter_category,
              filter_name: ga4Params.filter_name,
              filter_value: ga4Params.filter_value,
              filter_type: ga4Params.filter_type,
              filter_label: ga4Params.filter_label,
              page_location: ga4Params.page_location,
              page_path: ga4Params.page_path
            };

            if (!eventParams.filter_value || eventParams.filter_value === '') {
              eventParams.filter_value = String(filterValue || filterLabel || finalFilterValue || '');
            }

            gtag('event', 'filter_applied', eventParams);
          } catch (error) {
            console.error('Error sending GA4 filter_applied event:', error);
          }
        } else {
          console.warn('gtag function not available. GA4 event not sent.');
        }
      } else {
        console.warn('GA4 Event not sent: Missing required parameters', {
          filter_name: finalFilterName,
          filter_value: finalFilterValue,
          filterType: filterType,
          filterValue: filterValue,
          filterNameForGA: filterNameForGA
        });
      }
    }
  }

  getCleanLabelText(input) {
    let label = null;
    let text = '';

    label = input.nextElementSibling;
    if (label && (label.tagName === 'LABEL' || label.classList.contains('facet-checkbox') || label.textContent)) {
      text = label.textContent || '';
    }

    if (!text && input.closest('label')) {
      text = input.closest('label').textContent || '';
    }

    if (!text && input.id) {
      const associatedLabel = document.querySelector(`label[for="${input.id}"]`);
      if (associatedLabel) {
        text = associatedLabel.textContent || '';
      }
    }

    if (!text && input.parentElement) {
      text = input.parentElement.textContent || '';
    }

    if (text) {
      text = text.replace(/\s*\(\d+[^\)]*\)\s*/g, '');

      if (input.value) {
        text = text.replace(new RegExp(input.value, 'gi'), '').trim();
      }

      text = text.replace(/\s+/g, ' ').trim();

      text = text.replace(/^(filter|tag|type|vendor|price|availability|option)[:\s]+/i, '').trim();
    }

    if (!text && input.value) {
      return input.value;
    }

    return text;
  }

  trackSortingApplied(event) {
    const input = event.target;
    if (!input || input.name !== 'sort_by') return;

    const trackingKey = `sort_${input.value}`;
    const now = Date.now();

    if (window._lastSortTracking &&
      window._lastSortTracking.key === trackingKey &&
      now - window._lastSortTracking.time < 500) {
      return;
    }

    window._lastSortTracking = {
      key: trackingKey,
      time: now
    };

    let category = '';
    const pathParts = window.location.pathname.split('/');
    const collectionIndex = pathParts.indexOf('collections');
    if (collectionIndex !== -1 && pathParts[collectionIndex + 1]) {
      category = pathParts[collectionIndex + 1].replace(/-/g, ' ');
    }

    const sortValue = input.value;
    const sortLabel = this.getCleanLabelText(input) || this.getSortLabelName(sortValue) || sortValue;

    const eventData = {
      event: 'sort_applied',
      sort_type: String(sortLabel),
      sort_value: String(sortValue),
      category: category || '',
      page_location: window.location.href,
      page_path: window.location.pathname
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);

  }

  getSortLabelName(sortValue) {
    const sortLabels = {
      'manual': 'Featured',
      'best-selling': 'Best Selling',
      'title-ascending': 'Name: A to Z',
      'title-descending': 'Name: Z to A',
      'price-ascending': 'Price: Low to High',
      'price-descending': 'Price: High to Low',
      'created-ascending': 'Oldest',
      'created-descending': 'Newest'
    };
    return sortLabels[sortValue] || sortValue;
  }

  onSubmitHandler(event) {
    event.preventDefault();
    this.validatePrice(event);

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    let searchParams = '';

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      searchParams = this.createSearchParams(event.target.closest('form'));
    } else {
      const forms = [];
      const isMobile = event.target?.closest('form')?.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      searchParams = forms.join('&');
    }

    // GA4: Track filter applied with the searchParams that will be applied
    // Use setTimeout to ensure form state is captured correctly
    setTimeout(() => {
      this.trackFilterApplied(event, searchParams);
    }, 50);

    // GA4: Track sorting changes
    this.trackSortingApplied(event);

    this.onSubmitForm(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    // Track filter removal - send event with remaining active filters
    if (typeof gtag !== 'undefined') {
      try {
        const allFilters = this.getAllActiveFilters(url);
        const pathParts = window.location.pathname.split('/');
        const collectionIndex = pathParts.indexOf('collections');
        const category = collectionIndex !== -1 && pathParts[collectionIndex + 1]
          ? pathParts[collectionIndex + 1].replace(/-/g, ' ')
          : '';

        if (allFilters.categories.length > 0) {
          const eventParams = {
            filter_category: String(category || ''), // Page/Collection category: "raymond shirt", "shirts", etc.
            filter_value: String(allFilters.values.join(', ') || ''),
            filter_name: String(allFilters.categories.join(', ') || ''),
            page_location: String(window.location.href || ''),
            page_path: String(window.location.pathname || ''),
            filter_action: 'removed'
          };
          gtag('event', 'filter_applied', eventParams);
          console.log('GA4 Event sent: filter_applied (after removal)', eventParams);
        }
      } catch (error) {
        console.error('Error sending GA4 filter removal event:', error);
      }
    }

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.SIZE_PARAM = 'filter.v.option.size';
FacetFiltersForm.STOCK_PARAM = 'filter.v.availability';
FacetFiltersForm.AUTO_STOCK_KEY = 'facets-auto-size-stock';
FacetFiltersForm.autoStockFallback = false;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', FacetFiltersForm.applySizeStockOnLoad);
} else {
  FacetFiltersForm.applySizeStockOnLoad();
}

class PriceRange extends HTMLElement {

  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.setMinAndMaxValues();
  }


  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }


}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function removeDuplicateProducts() {
  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) return;
  const productItems = productGrid.querySelectorAll('li[data-product-id]');
  const seenProductIds = new Set();
  productItems.forEach((item) => {
    const productId = item.getAttribute('data-product-id');
    if (seenProductIds.has(productId)) {
      const nextElement = item.nextElementSibling
      item.remove();
      if (nextElement) {
        if (nextElement.classList.contains("product-grid__sale-image")) nextElement.remove()
      }
    } else {
      seenProductIds.add(productId);
    }
  });
}